import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

const cardTexts = [
  {
    image: IMAGES.didYouKnow.sausages,
    text: "Vi har et bredt udvalg af pølser, nøje udvalgt i samarbejde med vores loyale stamkunder. Du finder pølser fra Steff Houlberg, Tulip og vores lokale slagter."
  },
  {
    image: IMAGES.didYouKnow.sandwiches,
    text: "På menuen har vi også bøfsandwich lavet af friskhakket oksekød, flæskestegssandwich med saftig kamsteg, frikadeller fra en god slagter og mørbradsandwich med mørt svinemørbrad."
  },
  {
    image: IMAGES.didYouKnow.sauces,
    text: "Tilbehøret? Vi har selvfølgelig de klassiske favoritter som ketchup, sennep og remoulade. Men vi byder også på bearnaise, hjemmelavet chiliketchup for dem, der vil prøve noget ekstra lækkert."
  }
];

export default function DidYouKnowCard({ index }) {
  const { image, text } = cardTexts[index];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.2 }}
      className="group relative"
    >
      {/* Decorative background elements */}
      <div className="absolute -inset-4 bg-gradient-to-br from-red-500/5 to-amber-500/5 rounded-2xl blur-xl 
                    group-hover:from-red-500/10 group-hover:to-amber-500/10 transition-all duration-300" />
      
      <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
        {/* Image container with floating animation */}
        <motion.div
          animate={{ y: [-5, 5, -5] }}
          transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
          className="relative w-48 h-48 mx-auto mb-6"
        >
          {/* Glow effect */}
          <div className="absolute inset-0 bg-red-600/10 rounded-full blur-2xl group-hover:bg-red-600/20 transition-colors" />
          
          {/* Main image */}
          <motion.div
            whileHover={{ scale: 1.05, rotate: 3 }}
            className="relative w-full h-full rounded-full overflow-hidden shadow-2xl 
                     border-4 border-white/50 group-hover:border-white transition-colors"
          >
            <img
              src={image}
              alt="Pølsevogn fact"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </motion.div>
        </motion.div>

        {/* Text with vintage style */}
        <p className="text-gray-700 text-center leading-relaxed">
          {text}
        </p>
      </div>
    </motion.div>
  );
}